// plugins/sentry.client.ts
import * as Sentry from '@sentry/vue';
import { browserTracingIntegration } from '@sentry/browser';

export default defineNuxtPlugin((nuxtApp) => {
  const config = useRuntimeConfig();
  const router = useRouter();

  // Only initialize Sentry in production
  if (config.public.environment !== 'production') {
    console.log('[Sentry] Disabled in development');
    return;
  }

  if (!config.public.sentryDsn) {
    console.warn('Sentry DSN not found in runtime config');
    return;
  }

  try {
    Sentry.init({
      app: nuxtApp.vueApp,
      dsn: config.public.sentryDsn,
      environment: config.public.environment || 'development',
      release: '1.0', // Use the exact string to be sure
      integrations: [
        browserTracingIntegration({
          router,
        }),
      ],
      tracesSampleRate: config.public.environment === 'production' ? 0.1 : 1.0,
      beforeSend(event) {
        return event;
      },
      debug: config.public.environment !== 'production',
    });

    // Test Sentry is working
    // setTimeout(() => {
    //   try {
    //     throw new Error(
    //       'Sentry test error - this should appear in your Sentry dashboard'
    //     );
    //   } catch (e) {
    //     Sentry.captureException(e);
    //     console.log('Test error sent to Sentry');
    //   }
    // }, 2000);
  } catch (error) {
    console.error('Failed to initialize Sentry:', error);
  }

  // Global error handlers
  nuxtApp.vueApp.config.errorHandler = (err, instance, info) => {
    console.error('[Vue Error Handler]', err, info);
    Sentry.captureException(err, {
      tags: { errorHandler: 'vue' },
      extra: { info, instance: instance?.$options?.name || 'Unknown' },
    });
  };

  // Handle unhandled promise rejections
  window.addEventListener('unhandledrejection', (event) => {
    console.error('[Unhandled Promise Rejection]', event.reason);
    Sentry.captureException(event.reason, {
      tags: { errorHandler: 'unhandledrejection' },
    });
  });

  // Handle window errors
  window.addEventListener('error', (event) => {
    console.error('[Window Error]', event.error || event.message);
    Sentry.captureException(event.error || new Error(event.message), {
      tags: { errorHandler: 'window' },
    });
  });

  // Handle Nuxt errors
  nuxtApp.hook('app:error', (error) => {
    console.error('[Nuxt App Error]', error);
    Sentry.captureException(error, {
      tags: { errorHandler: 'nuxt' },
    });
  });
});
